import axios from "../api/axiosClient";
import { useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Input,
  Typography,
  FormLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CustomInput from "../components/ui/CustomInput";
import LoopIcon from "@mui/icons-material/Loop";
import PlaylistAddOutlinedIcon from "@mui/icons-material/PlaylistAdd";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import CustomTable from "../components/ui/CustomTable";
import { Toaster, toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { useLoading } from "../components/LoadingContext";
import { useIntl } from "react-intl";
import {
  getFile,
  addDownloadLinkToDocument,
  handleError,
  errorToast,
} from "../services/serviceBase";
import store from "../redux/store";
import moment from "moment";

const BasketMaintenance = (props) => {
  const intl = useIntl();
  let location = useLocation();
  const { setLoading } = useLoading();

  const queryParameters = new URLSearchParams(window.location.search);
  let storeId = null;
  for (const [name, value] of queryParameters) {
    if (name.toLowerCase() == "storeid") {
      storeId = value;
    }
  }

  const [baskets, setBaskets] = useState([]);
  const [basketsForSelect, setBasketsForSelect] = useState([]);
  const [selectedBasket, setSelectedBasket] = useState("");
  const [basketDetails, setBasketDetails] = useState([]);
  const [jdaLocationDestination, setJdaLocationDestination] = useState("");
  const [isAPEEvoBrand, setIsAPEEvoBrand] = useState(null);

  const [columns, setColumns] = useState([]);
  const fixture = useRef();
  const sku = useRef();

  const [changedBasketQty, setChangedBasketQty] = useState([]);

  const getColumns = async () => {
    setColumns([
      {
        field: "fixture",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Fixture</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>{params.row.carton}</Typography>
          );
        },
      },
      {
        field: "sku",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>SKU</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>
              {params.row.barcode}
              {params.row.checkDigit}
            </Typography>
          );
        },
      },
      {
        field: "style",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Style</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>
              {params.row.styleCode}
            </Typography>
          );
        },
      },
      {
        field: "fabric",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Fabric</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>
              {params.row.fabricCode}
            </Typography>
          );
        },
      },
      {
        field: "color",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Color</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>
              {params.row.colorCode}
            </Typography>
          );
        },
      },
      {
        field: "size",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Size</Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <Typography sx={{ color: "white" }}>
              {params.row.sizeDescription}
            </Typography>
          );
        },
      },
      {
        field: "qty",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Qty</Typography>
        ),
        flex: 1,
        minWidth: 20,
        renderCell: (params) => {
          return (
            <Input
              type="number"
              className="basketMInputText"
              id={params.row.idS2SBasketDetail}
              name={params.row.idS2SBasketDetail}
              defaultValue={params.row.quantity}
              onChange={(e) => handleDetailQtyChange(e, params.row)}
            />
          );
        },
      },
      {
        field: "remove",
        headerClassName: "grid-header basketMaintenanceGridHeader",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>Remove</Typography>
        ),
        flex: 1,
        verticalAlign: "center",
        minWidth: 50,
        renderCell: (params) => {
          return (
            <IconButton
              sx={{ color: "white", p: 0 }}
              onClick={(e) => handleDeleteRow(e, params.row)}
            >
              <DeleteIcon fontSize="large" />
            </IconButton>
          );
        },
      },
    ]);
  };

  const getBaskets = () => {
    const params = new URLSearchParams([]);
    params.append("storeId", storeId);

    axios
      .get("s2s/basketmaintenance/baskets", { params })
      .then((response) => {
        setBaskets(response.data);
        var selectItems = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            let date = moment(x.creationDate).format("YYYY/MM/DD HH:mm:ss");
            let textMessage = `${date} - ${x.salePriceType} - ${x.affinityGroupDesc}`;
            selectItems.push({ value: x.idS2SBasket, text: textMessage });
          });
        }
        setBasketsForSelect(selectItems);
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  const getBrandCodeOfStore = () => {
    const params = new URLSearchParams([]);
    params.append("storeId", storeId);

    axios
      .get("s2s/basketmaintenance/brandOfStore", { params })
      .then((response) => {
        if (response.data != null) {
          setIsAPEEvoBrand(response.data);
        }
      })
      .catch((error) => {
        handleError(error, intl, () => {
          setIsAPEEvoBrand(false);
        });
      });
  };

  useEffect(() => {
    if (isAPEEvoBrand == null) {
      getBrandCodeOfStore();
    } else {
      handleRedirect();
    }
  }, [isAPEEvoBrand]);

  const handleRedirect = () => {
    if (storeId == null) {
      toast.error("No store id in query params");
      return;
    }

    if (isAPEEvoBrand) {
      getBaskets();
    } else {
      var apeBasketMaintenanceURL =
        process.env.REACT_APP_APE_BASKET_MAINTENACE + storeId;
      window.location.replace(apeBasketMaintenanceURL);
    }
  };

  const handleRefreshBaskets = () => {
    if (selectedBasket !== "") {
      setSelectedBasket("");
      setJdaLocationDestination("");
    }
    getBaskets();
  };

  const handleChangeSelectedBasket = (selectedBasketId) => {
    let currentBasket = baskets.find((x) => x.idS2SBasket == selectedBasketId);
    if (currentBasket != null && currentBasket != undefined) {
      setSelectedBasket(selectedBasketId);
      let destination = `${currentBasket.jdaLocationOfDestination} ${currentBasket.jdaDescriptionOfDestination}`;
      setJdaLocationDestination(destination);
    } else {
      setSelectedBasket("");
      setJdaLocationDestination("");
    }
  };

  const getBasketDetails = (idS2SBasket) => {
    axios
      .get("s2s/basketmaintenance/" + idS2SBasket + "/basketDetails")
      .then((response) => {
        setBasketDetails(response.data);
        getColumns();
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (selectedBasket != "") {
      getBasketDetails(selectedBasket);
    } else {
      setBasketDetails([]);
    }
  }, [selectedBasket]);

  const handleAddSku = (e) => {
    e.preventDefault();
    if (selectedBasket == "") {
      toast.error(intl.formatMessage({ id: "BasketMaintenance.SelectBasket" }));
      return;
    }
    if (
      fixture.current.value == "" ||
      fixture.current.value == null ||
      fixture.current.value == undefined
    ) {
      toast.error(
        intl.formatMessage({ id: "BasketMaintenance.InsertFixture" })
      );
      return;
    }
    if (
      sku.current.value == "" ||
      sku.current.value == null ||
      sku.current.value == undefined
    ) {
      toast.error(intl.formatMessage({ id: "BasketMaintenance.InsertSKU" }));
      return;
    }

    var data = {
      Carton: fixture.current.value,
      Barcode: sku.current.value,
    };

    var url = "s2s/basketmaintenance/" + selectedBasket + "/basketDetails/";
    axios
      .post(url, data)
      .then((response) => {
        setBasketDetails([]);
        getBasketDetails(selectedBasket);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleSaveBasket = () => {
    let data = [];
    changedBasketQty.map((x) =>
      data.push({
        idS2SBasketDetail: x.idS2SBasketDetail,
        quantity: x.quantity,
      })
    );

    basketDetails.map((x) => {
      let alreadyChangedItem = data.find(
        (z) => z.idS2SBasketDetail == x.idS2SBasketDetail
      );
      if (alreadyChangedItem == null || x.idS2SBasketDetail == undefined) {
        data.push({
          idS2SBasketDetail: x.idS2SBasketDetail,
          quantity: x.quantity,
        });
      }
    });

    var url = "s2s/basketmaintenance/" + selectedBasket + "/basketDetails/";
    axios
      .put(url, data)
      .then((response) => {
        setBasketDetails([]);
        getBasketDetails(selectedBasket);
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  const handleDeleteRow = (e, row) => {
    e.preventDefault();
    axios
      .delete(
        "s2s/basketmaintenance/" +
          row.idS2SBasket +
          "/basketDetails/" +
          row.idS2SBasketDetail
      )
      .then((response) => {
        getBasketDetails(row.idS2SBasket);
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  const handleDetailQtyChange = (e, row) => {
    e.preventDefault();
    let items = changedBasketQty;

    var alreadyChangedQtyItemIndex = items.indexOf(
      items.find((x) => x.idS2SBasketDetail == row.idS2SBasketDetail)
    );
    if (
      alreadyChangedQtyItemIndex > -1 &&
      alreadyChangedQtyItemIndex !== null &&
      alreadyChangedQtyItemIndex !== undefined
    ) {
      items[alreadyChangedQtyItemIndex].quantity = e.target.value;
    } else {
      items.push({
        idS2SBasketDetail: row.idS2SBasketDetail,
        quantity: e.target.value,
      });
    }

    setChangedBasketQty(items);
  };

  const handleDeleteBasket = () => {
    axios
      .delete("s2s/basketmaintenance/" + selectedBasket + "/baskets/")
      .then((response) => {
        setBaskets([]);
        setBasketDetails([]);
        setChangedBasketQty([]);
        handleRefreshBaskets();
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  const handlePrintBasket = () => {
    var url = "s2s/basketmaintenance/" + selectedBasket + "/basketReport";
    getFile(
      url,
      (response) => {
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        handleError(error, intl);
      },
      null
    );
  };

  const handleFinalizeProcess = () => {
    let data = [];
    changedBasketQty.map((x) =>
      data.push({
        idS2SBasketDetail: x.idS2SBasketDetail,
        quantity: x.quantity,
      })
    );

    basketDetails.map((x) => {
      let alreadyChangedItem = data.find(
        (z) => z.idS2SBasketDetail == x.idS2SBasketDetail
      );
      if (alreadyChangedItem == null || x.idS2SBasketDetail == undefined) {
        data.push({
          idS2SBasketDetail: x.idS2SBasketDetail,
          quantity: x.quantity,
        });
      }
    });
    axios
      .post("s2s/basketmaintenance/" + selectedBasket + "/baskets", data)
      .then((response) => {
        setLoading(false);
        setBaskets([]);
        setBasketDetails([]);
        setChangedBasketQty([]);
        handleRefreshBaskets();
        handlePrintBasket();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    getColumns();
  }, [basketDetails]);

  const handleGoToBasketPackaging = () => {
    var apeBasketMaintenanceURL =
      process.env.REACT_APP_APE_BASKET_MAINTENACE + storeId;
    window.location.replace(apeBasketMaintenanceURL);
  };

  return (
    <Box>
      <style type="text/css">
        body &#123; background-color: black; color: white !important; &#125;
      </style>
      {!isAPEEvoBrand ? (
        "LOADING..."
      ) : (
        <Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h6"> Basket Maintenance</Typography>
          </Box>
          <Button
            sx={{
              fontSize: 18,
              color: "white",
              textDecoration: "underline",
              textTransform: "capitalize",
            }}
            onClick={handleGoToBasketPackaging}
          >
            [Basket Packaging]
          </Button>
          <Grid container>
            <Grid item sm={4.6}>
              <CustomInput
                type="select"
                id="basket"
                classLabel="basketMColor"
                classInput="basketMSelect"
                selectItems={basketsForSelect}
                valueRef={selectedBasket}
                setValue={handleChangeSelectedBasket}
                labelText="Basket"
                textCol={2.2}
                inputCol={9.8}
              />
            </Grid>
            <Grid item sm={0.5}>
              <IconButton
                aria-label="delete"
                sx={{ color: "gray" }}
                onClick={handleRefreshBaskets}
              >
                <LoopIcon
                  fontSize="large"
                  sx={{ transform: "rotate(130deg);" }}
                />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={0.8} sx={{ ml: 1 }}>
              <Typography>Destination</Typography>
            </Grid>
            <Grid item lg={3} sx={{ ml: 0.8 }}>
              <Typography>{jdaLocationDestination}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item sm={5}>
              <CustomInput
                type="text"
                id="fixture"
                classLabel="basketMColor"
                classInput="basketMInputText"
                valueRef={fixture}
                labelText="Fixture"
                textCol={2}
                inputCol={9}
              />
            </Grid>
            <Grid item sm={5}>
              <Grid container>
                <Grid item sm={10}>
                  <CustomInput
                    type="text"
                    id="sku"
                    classLabel="basketMColor"
                    classInput="basketMInputText"
                    valueRef={sku}
                    labelText="Sku"
                    textCol={1.5}
                    inputCol={10.5}
                  />
                </Grid>
                <Grid item sm={0.5}>
                  <IconButton
                    aria-label="delete"
                    sx={{ color: "gray" }}
                    onClick={handleAddSku}
                  >
                    <PlaylistAddOutlinedIcon sx={{ fontSize: 40 }} />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box sx={{ bgcolor: "grey", verticalAlign: "middle" }}>
            <Grid container>
              <Grid item sm={0.4}>
                <IconButton sx={{ color: "black" }} onClick={handleSaveBasket}>
                  <SaveIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid item sm={0.4}>
                <IconButton
                  sx={{ color: "black" }}
                  onClick={handleDeleteBasket}
                >
                  <DeleteIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid item sm={0.4}>
                <IconButton sx={{ color: "black" }} onClick={handlePrintBasket}>
                  <PrintIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid item sm={7.8}></Grid>
              <Grid item sm={3} textAlign="right">
                <Button
                  sx={{
                    mt: 0.2,
                    fontSize: 18,
                    color: "white",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={handleFinalizeProcess}
                >
                  [Finalize Process]
                </Button>
              </Grid>
            </Grid>
          </Box>

          {basketDetails.length > 0 ? (
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={7}>
                <CustomTable
                  columns={columns}
                  rows={basketDetails}
                  id={"idS2SBasketDetail"}
                  rowHeight={40}
                  headerHeight={40}
                />
              </Grid>
            </Grid>
          ) : (
            <Box></Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default BasketMaintenance;
